import { useMutation } from '@tanstack/react-query';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../api/adminDataProvider';
import { ExportToEmailButton } from '../../components/custom/ExportToEmailButton';

export function JourneyReportEmailButton() {
  const httpClient = useDataProvider<AdminDataProvider>();
  const sendEmail = useMutation({
    mutationFn: (emails: string[]) => {
      return httpClient.requestJourneyReportEmail({
        destinationEmailAddresses: emails,
      });
    },
  });

  return (
    <ExportToEmailButton
      onSubmit={(emails, options) => sendEmail.mutate(emails, options)}
      isSubmitting={sendEmail.isPending}
    />
  );
}
